import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  loadLitePlayerJSFiles,
  setSlikeConfig,
  handleEvents,
  playerErrorCallback,
  playerloadError,
} from './util';

const Player = props => {
  const {
    divId,
    slikeId,
    isMobile,
    videoClassName,
    globalRefId,
    isEtimes,
    isFullPlayer,
  } = props;

  useEffect(() => {
    const pageProps = {};
    let slikeApiKey;
    if (isEtimes) {
      slikeApiKey = isMobile ? 'toi371mweb5awm99g9o6' : 'toi371web5awj999ou6';
    } else {
      slikeApiKey = isMobile
        ? 'toimweb5t9tCpb7nb5q6jUb'
        : 'toiweba5ec9705eb7ac2c984033e061';
    }
    pageProps.apiKey = slikeApiKey;
    pageProps.isFullPlayer = isFullPlayer;
    const afterPlayerLoaded = recheckCount => {
      const CleoPlayer = window?.CleoPlayer;
      if (CleoPlayer) {
        const slikeConfig = setSlikeConfig(props, pageProps);
        window.lwPlayer = window.lwPlayer || {};
        window.lwPlayer[globalRefId] = new CleoPlayer(slikeConfig, error => {
          if (error) {
            console.error(error);
            playerErrorCallback(error, props);
            return;
          }
          const player = window.lwPlayer[globalRefId];
          handleEvents(player, CleoPlayer.Events, props);
        });
      } else if (recheckCount > 3) {
        playerloadError('CleoPlayer not found');
        console.error('CleoPlayer not found');
      } else {
        setTimeout(() => {
          afterPlayerLoaded(recheckCount + 1);
        }, 3000 * recheckCount);
      }
    };

    loadLitePlayerJSFiles(pageProps, () => {
      afterPlayerLoaded(1);
    });
  }, []);

  if (!slikeId || !divId) {
    return null;
  }
  return <div id={divId} className={videoClassName} />;
};
const mapStateToProps = state => ({
  isMobile: state.isMobile,
  isPrime: state.isPrime,
});
Player.propTypes = {
  divId: PropTypes.string.isRequired,
  slikeId: PropTypes.string.isRequired,
  videoClassName: PropTypes.string,
  globalRefId: PropTypes.string,
  isMobile: PropTypes.bool,
  isEtimes: PropTypes.bool,
  isFullPlayer: PropTypes.bool,
};
Player.defaultProps = {
  isMobile: false,
  videoClassName: '',
  globalRefId: 'common',
  isEtimes: false,
  isFullPlayer: false,
};
export default connect(mapStateToProps)(Player);
